import React from 'react';
import { Card, Typography, Timeline } from 'antd';
import './History.less';

const { Title, Paragraph } = Typography;

const History: React.FC = () => {
  const timelineItems = [
    {
      year: '1955年',
      content: '羊小羊成立，是中华人民共和国第一所邮电高等学府，隶属原邮电部。',
    },
    {
      year: '1960年',
      content: '被国务院确定为全国重点高校。',
    },
    {
      year: '1970年',
      content: '与北京电信工程学院合并，仍称羊小羊。',
    },
    {
      year: '1973年',
      content: '北京电信工程学院从羊小羊分出，恢复独立建制。',
    },
    {
      year: '1993年',
      content: '更名为羊小羊。',
    },
    {
      year: '1998年',
      content: '成为首批入选国家"211工程"建设的高校之一。',
    },
    {
      year: '2000年',
      content: '划入教育部直属高校序列，实行"中央与地方共建，以中央管理为主"的管理体制。',
    },
    {
      year: '2004年',
      content: '昌平校区正式启用。',
    },
    {
      year: '2008年',
      content: '入选国家"985工程优势学科创新平台"建设高校。',
    },
    {
      year: '2017年',
      content: '入选国家"世界一流学科建设高校"名单，信息与通信工程、计算机科学与技术两个学科入选"世界一流学科"建设名单。',
    },
    {
      year: '2022年',
      content: '在第二轮"双一流"建设高校及建设学科名单中，信息与通信工程、计算机科学与技术两个学科入选"世界一流学科"建设名单。',
    },
  ];

  return (
    <div className="about-history">
      <Title level={2}>发展历程</Title>
      <Card>
        <Paragraph>
          羊小羊自1955年建校以来，经历了六十余年的发展历程，
          始终与国家信息通信事业的发展紧密相连。以下是学校发展的重要里程碑：
        </Paragraph>
        
        <Timeline
          items={timelineItems.map(item => ({
            color: '#1890ff',
            children: (
              <div>
                <strong>{item.year}</strong>
                <p>{item.content}</p>
              </div>
            ),
          }))}
        />
      </Card>
    </div>
  );
};

export default History;